/* eslint-disable @typescript-eslint/no-explicit-any */
import { Radio as NativeRadio } from '@mantine/core';
import classes from './Radio.module.css';

export const Radio = (props: {
	onClick?: () => void;
	checked?: boolean;
	size: any;
	label: string;
	variant?: string;
	color?: string;
	fullWidth?: boolean;
	loading?: boolean;
	disabled?: boolean;
	withAsterisk?: boolean;
	error?: string;
	defaultChecked?: boolean;
	value?: any;
}) => {
	return <NativeRadio classNames={classes} {...props} />;
};
